import React, { Component } from 'react';
import { ActionType, GameFinishStatus, CellType } from './OnlineEnums';

export class OnlinePlayerControls extends Component {

  constructor(props) {
      super(props);

      this.state = { selectedWordCount: 1, selectedWord: "" };
    }

    getRemainingCounters() {
        return this.props.countersLeft;
    }

    getRemainingGreens() {
        return this.props.unrevealedGreensLeft;
    }

    getStateText() {
        if (this.props.nextAction === ActionType.Finished) {
            switch (this.props.gameFinishStatus) {
                case GameFinishStatus.Assassinated: return "FELL IN A TRAP";
                case GameFinishStatus.Success: return "SUCCEEDED! CONGRATS!";
                case GameFinishStatus.TimeRanOut: return "Out of turns :(";
                default: return "Unknown end";
            }
        }

        if (this.props.isWaitingForAction)
            return this.getStateTextForUs();

        switch (this.props.nextAction) {
            case ActionType.Guess: return "Waiting for other player to make a guess";
            case ActionType.GiveHint: return "Waiting for other player to give a hint";
            case ActionType.ConfirmGuess: return "Waiting for other player to confirm your guess";
        }
        return "Waiting for other player's action";
    }

    getHelperTextForState() {
        if (this.props.nextAction === ActionType.Finished) {
            return "Game is finished. Game master can continue to next game.";
        }

        if (!this.props.isWaitingForAction)
            return "";

        switch (this.props.nextAction) {
            case ActionType.GiveHint: return "Enter hint word, select how many green words on the grid it associates and click the button";
            case ActionType.FirstHint: return "Enter hint word, select how many green words on the grid it associates and click the button";
            case ActionType.Guess: return "Go through the hints given by the other player(s) and guess the associated words on the grid by clicking them"
            case ActionType.ConfirmGuess: return "Confirm the other player(s)' guess by clicking on the corresponding color";
            default: return "";
        }
    }

    getStateTextForUs() {
        switch (this.props.nextAction) {
            case ActionType.GiveHint:
            case ActionType.FirstHint:
                return "GIVE A HINT!";
            case ActionType.Guess: return "MAKE A GUESS!";
            case ActionType.ConfirmGuess: return "Confirm other player's guess!";
            default: return "Unknown: " + this.props.nextAction;
        }
    }

    getGiveHintContent() {
        return (
            <div>
                <label>
                    Hint word (single word that doesn't appear on the grid)
                    <input value={this.state.selectedWord} type="text" pattern="[a-zA-Z���]+" onChange={x => this.setState({ selectedWord: x.target.value })} />
                </label>
                <label>How many words in the grid this associates with
                    <select value={this.state.selectedWordCount} onChange={x => this.setState({ selectedWordCount: parseInt(x.target.value) })}>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                    </select>
                </label>
                <button className={"btn btn-primary"} onClick={async () => await this.props.giveHintFunc(this.state.selectedWord, this.state.selectedWordCount)}>GIVE A HINT</button>
            </div>
            );
    }

    getButtonContent() {
        if (this.props.nextAction === ActionType.Finished)
            return this.getRematchButton();

        if (!this.props.isWaitingForAction)
            return "";

        switch (this.props.nextAction) {
            case ActionType.GiveHint:
            case ActionType.FirstHint:
                return this.getGiveHintContent();
            case ActionType.Guess:
                return (<button className={"btn btn-primary"} onClick={() => this.props.concedeTurnAction()}>QUIT GUESSING</button>);
        }

        return "";
    }

    getRematchButton() {
        if (this.props.nextAction !== ActionType.Finished || !this.props.isGameMaster)
            return "";

        return (
            <button className={"btn btn-primary"} onClick={async () => await this.props.rematchFunc()}>Rematch!</button>
        );
    }

    getRegularContent() {
        return (
            <div className="playerInputStack">
                <div>
                    <h4>Status: {this.getStateText()}</h4>
                    <p>{this.getHelperTextForState()}</p>
                    <p>Turns left: {this.props.countersLeft}. Unguessed greens left: {this.props.unrevealedGreensLeft}</p>
                </div>
                <div>
                    {this.getButtonContent()}
                </div>

                <div>
                    <h4>Hints I've given</h4>
                    <ul>
                        {this.props.givenHints.map((h,i) => <li key={"myhint"+i}>{h.number} - {h.word}</li>)}
                    </ul>
                </div>
                
            </div>);
    }

    async selectColor(color) {
        await this.props.confirmGuessFunc();
    }

    getSelectingColorContent() {
        return (
            <div className="playerControls">
                <button className="btn cardColorSelectButton blackcard" onClick={async () => await this.selectColor()}>BLACK</button>
                <button className="btn cardColorSelectButton greencard" onClick={async () => await this.selectColor()}>GREEN</button>
                <button className="btn cardColorSelectButton yellowcard" onClick={async () => await this.selectColor()}>YELLOW</button>
            </div>);
    }

    getConditionalElements() {
        if (this.props.nextAction === ActionType.ConfirmGuess && this.props.isWaitingForAction) {
            return this.getSelectingColorContent();
        } else {
            return this.getRegularContent();
        }
    }

    getRejoinLinkElement() {
        return "";
        /*return (
            <div>
                <h4>Link via which disconnected player can rejoin this game</h4>
                <label>{this.props.rejoinLinkGetterFunc()}</label>
            </div>
            );*/
    }

    getConnectionInfoElement() {
        return (
            <div>
                {this.getRejoinLinkElement()}
            </div>
            )
    }

    getCellTypeClass(cellType) {
        switch (cellType) {
            case CellType.Black: return "blackcard";
            case CellType.Green: return "greencard";
            case CellType.Yellow: return "yellowcard";
            default: return "";
        }
    }

    getOurColorGrid() {
        return (
            <div className="ourColorsGrid">
                {this.props.ourCellTypes.map((c, i) => <div key={"ct" +i} className={"ourColorCell " + this.getCellTypeClass(c) } />)}
            </div>
        );
    }

    render() {
        return (
            <div className="elementStack">
                <div className="playerControls">
                    {this.getConditionalElements()}
                    {this.getOurColorGrid()}
                </div>
                <div>
                    {this.getConnectionInfoElement()}
                </div>
            </div>
        );
    }
}
